export const invertedMessages = {
  Clear: 'CERTS_CLEAR',
  'Remove Filter': 'CERTS_REMOVE_FILTER',
  'No data available': 'CERTS_NO_DATA_AVAILABLE',
  Search: 'Popup.SearchForm',
  User: 'User_DISPLAYNAME.CERTIFICATIONS',
  Account: 'Account_DISPLAYNAME.CERTIFICATIONS',
  Entitlement: 'Ent_DISPLAYNAME.CERTIFICATIONS',
  Role: 'Role_DISPLAYNAME.CERTIFICATIONS',
  'Child Entitlement': 'ChildEnt_DISPLAYNAME.CERTIFICATIONS',
  // need db changes
  Loading: 'CERTS_LOADER',
  'Clear Filter': 'CERTS_CLEAR_FILTER',
  'Clear All': 'CERTS_CLEAR_ALL',
  'See Results ({totalItems})': 'CERTS_FILTER_RESULTS',
  'Applied to: {types}': 'CERTS_APPLIED_TO_TYPES',
};
